module.exports = __webpack_public_path__ + "img/Medical Insurance.42d9a124.svg";